import { Auth } from 'aws-amplify'
import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { toast } from 'react-toastify'
import TagPersonsAtHeaderLevelToMovieList from '../../Services/Mutations/tagPersonsAtHeaderLevelToMovieList'
import UntagPersonsAtHeaderLevelFromMovieList from '../../Services/Mutations/UntagPersonsAtHeaderLevelFromMovieList'
import GetMoviesCastAndCrew from '../../Services/Queries/GetMoviesCastAndCrew'
import { ToastStyle } from '../Data/MovieStaticData'
import AutoSuggestionsdata from '../Movie/Autosuggestionsdata'

const TagHeadearLevel = forwardRef((props, ref) => {
  const {
    movieListID,
    initialHeaderPersons,
    editMode,
    // setSelectedMovieOrPersonData,
    selectedListType,
    selectedMovieOrPersonData,
    setvalueEdited,
    sendLoadSpinner,
  } = props
  const [headerLevelPersons, setheaderLevelPersons] = useState([])
  const [autoSuggestion, setAutoSuggestions] = useState([])
  const [filteredNames, setfilteredNames] = useState([])
  const [Name, setName] = useState('')
  const [duplicate, setDuplicate] = useState(false)
  let loggedInUserHandle = ''
  const loggedInUserEmail = Auth.user.attributes ? Auth.user.attributes.email : ''
  if (loggedInUserEmail) {
    const emailParams = loggedInUserEmail.split('@')
    loggedInUserHandle = '@' + emailParams[0]
  }

  const personIDs = headerLevelPersons?.map(e => (e.personID ? e.personID : e.PK))

  async function TaggedPersonHeader() {
    // const personIDs = personsAdded.map(e => e.personID ? e.personID : e.PK)
    const input = {
      movieListID,
      addedByID: Auth.user.username,
      addedByHandle: loggedInUserHandle,
      personIDs,
    }
    const response = await TagPersonsAtHeaderLevelToMovieList(input)
    if (response.statusCode === 'A047') {
      toast.success(response.statusMessage, ToastStyle)
    }
  }

  async function unTagPearsonHeader(personsRemoved) {
    const untagPersonsIds = personsRemoved.map(e => e.personID)
    const input = {
      movieListID,
      personIDs: untagPersonsIds,
    }
    const response = await UntagPersonsAtHeaderLevelFromMovieList(input)
    if (response.statusCode === 'A048') {
      toast.success(response.statusMessage, ToastStyle)
    }
  }

  useImperativeHandle(ref, () => ({
    async handlePersonChanges() {
      const personsAdded = headerLevelPersons.filter(
        person =>
          !initialHeaderPersons ||
          !initialHeaderPersons.some(
            p => p.personID === person.personID || p.PK === person.personID,
          ),
      )

      if (personsAdded.length > 0) {
        await TaggedPersonHeader()
      }

      if (editMode && initialHeaderPersons && initialHeaderPersons.length > 0) {
        const personsRemoved = initialHeaderPersons.filter(
          person =>
            !headerLevelPersons.some(
              p => p.personID === person.personID || p.PK === person.personID,
            ),
        )
        if (personsRemoved.length > 0) {
          await unTagPearsonHeader(personsRemoved)
        }
      }
    },
  }))
  // async function TaggedPersonHeader(personsAdded) {
  //   const personIDs = personsAdded.map(e => (e.personID ? e.personID : e.PK))
  //   const input = {
  //     movieListID,
  //     addedByID: Auth.user.username,
  //     addedByHandle: loggedInUserHandle,
  //     personIDs,
  //   }
  //   const response = await TagPersonsAtHeaderLevelToMovieList(input)
  //   if (response.statusCode === 'A047') {
  //     toast.success(response.statusMessage, ToastStyle)
  //   }
  // }

  // async function unTagPearsonHeader(personsRemoved) {
  //   const untagPersonsIds = personsRemoved.map(e => e.personID)
  //   const input = {
  //     movieListID,
  //     personIDs: untagPersonsIds,
  //   }
  //   const response = await UntagPersonsAtHeaderLevelFromMovieList(input)
  //   if (response.statusCode === 'A048') {
  //     toast.success(response.statusMessage, ToastStyle)
  //   }
  // }

  const SelectionFromSuggestion = event => {
    const headerLevelPersonsTemp = [...headerLevelPersons]
    const selectedIndex = filteredNames.findIndex(obj => obj.label === event.target.innerText)
    const isObjectAlreadyExists = (array, idToCheck) =>
      array.some(obj => obj.personID === idToCheck)
    const objectExists = isObjectAlreadyExists(
      headerLevelPersonsTemp,
      autoSuggestion.personHits[selectedIndex].personID,
    )
    setDuplicate(objectExists)
    headerLevelPersonsTemp.push(autoSuggestion.personHits[selectedIndex])
    const arrayObjects = removeDuplicates(headerLevelPersonsTemp, 'personID')
    setheaderLevelPersons(arrayObjects)
    setName('')
    setfilteredNames([])
    setAutoSuggestions([])
    setvalueEdited(true)
  }

  function removeDuplicates(arr, idKey) {
    const uniqueIds = new Set()
    const uniqueObjects = []

    for (const obj of arr) {
      if (!uniqueIds.has(obj[idKey])) {
        uniqueIds.add(obj[idKey])
        uniqueObjects.push(obj)
      }
    }

    return uniqueObjects
  }

  const removePersonFromHeaderTaggedPersons = index => {
    const headerLevelPersonsTemp = [...headerLevelPersons]
    headerLevelPersonsTemp.splice(index, 1)
    setheaderLevelPersons(headerLevelPersonsTemp)
    setvalueEdited(true)
  }

  const GetPersons = async () => {
    sendLoadSpinner(true)
    const input = {
      movieIDs: selectedMovieOrPersonData.map(moviepersoninfo =>
        moviepersoninfo.PK.includes('movieList#')
          ? moviepersoninfo.SK.includes('Text#')
            ? moviepersoninfo.SK.replace('Text#', '')
            : moviepersoninfo.SK
          : moviepersoninfo.PK,
      ),
    }
    const response = await GetMoviesCastAndCrew(input)
    const headerLevelPersonsTemp = [...headerLevelPersons]

    if (response && response.items) {
      const castAndCrew = response.items ? response.items.map(e => ({ ...e, personID: e.PK })) : []
      headerLevelPersonsTemp.push(...castAndCrew)
      const arrayObjects = removeDuplicates(headerLevelPersonsTemp, 'personID')
      setheaderLevelPersons(arrayObjects)
      setvalueEdited(true)
      sendLoadSpinner(false)
    }
  }

  const ClearAllHeaderLevelPersons = () => {
    setheaderLevelPersons([])
    setvalueEdited(true)
  }

  const handleNameChange = async value => {
    setName(value)
    if (value === '') {
      setfilteredNames([])
    }

    if (value.length >= 3) {
      try {
        const moviePersonData = await AutoSuggestionsdata(value)
        const updatedPersonHits = moviePersonData.personHits.map(e => ({ ...e, personID: e.PK }))
        const updatedData = { ...moviePersonData, personHits: updatedPersonHits }
        setAutoSuggestions(updatedData)
        const filteredNames = moviePersonData
          ? moviePersonData.personHits.map(e => ({ label: e.name_En }))
          : []
        setfilteredNames(filteredNames)
        // setfilteredcrewNamesTelugu(filteredcrewNameste)
      } catch {
        setAutoSuggestions([])
        setfilteredNames([])
        // setfilteredcrewNamesTelugu([])
        // console.warn(error)
      }
    }
  }

  useEffect(() => {
    if (editMode) {
      setheaderLevelPersons(initialHeaderPersons ? initialHeaderPersons : [])
    }
  }, [initialHeaderPersons])
  return (
    <>
      <div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <label>HeaderLevel TaggedPersons:</label>
          <div style={{ display: 'flex', gap: '10px' }}>
            {selectedListType === 'Movie' &&
              selectedMovieOrPersonData &&
              selectedMovieOrPersonData.length >= 1 && (
                <button
                  type='button'
                  className='btn btn-primary'
                  style={{ margin: '10px', float: 'right' }}
                  onClick={() => GetPersons()}
                >
                  GetTagPersons
                </button>
              )}
            {headerLevelPersons && headerLevelPersons.length >= 1 && (
              <button
                type='button'
                className='btn btn-primary'
                style={{ margin: '10px', float: 'right' }}
                onClick={() => ClearAllHeaderLevelPersons()}
              >
                Clear All
              </button>
            )}
          </div>
        </div>
        {headerLevelPersons && headerLevelPersons.length >= 1 && (
          <div
            className='card'
            style={{
              display: 'flex',
              flexDirection: 'row',
              flexWrap: 'wrap',
              justifyContent: 'flex-start',
              alignItems: 'center',
              gap: '0.3rem',
              padding: '1rem',
            }}
          >
            {headerLevelPersons &&
              headerLevelPersons.map(
                (persons, personsIndex) => (
                  // persons.map((person, personIndex) => (
                  <div className='TaggedPersonData' key={personsIndex}>
                    <div
                      style={{
                        borderRadius: '1rem',
                        backgroundColor: '#ededed',
                      }}
                      className='d-flex justify-content-start align-items-center pl-2 pr-2 mt-1 mb-1'
                    >
                      <span className='mr-2'>{persons.name_En} </span>
                      <span
                        style={{
                          borderRadius: '50%',
                          color: 'white',
                          backgroundColor: '#474747',
                          padding: '2px 5px',
                          fontSize: '8px',
                        }}
                        onClick={() => removePersonFromHeaderTaggedPersons(personsIndex)}
                      >
                        X
                      </span>
                    </div>
                  </div>
                ),
                // )),
              )}
          </div>
        )}
        <div>
          {
            <input
              type={'text'}
              className='form-control'
              // style={props.modeUrl && indication}
              value={Name}
              onChange={e => handleNameChange(e.target.value)}
            ></input>
          }
          {filteredNames.length >= 1 && (
            <div className='searchfield' style={{ width: '28%' }}>
              {filteredNames.map((Name, NameIndex) => (
                <div key={NameIndex} onClick={event => SelectionFromSuggestion(event)}>
                  <label>{Name.label}</label>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
      {duplicate && <span className='mandatory1'>Person Already Exists</span>}
    </>
  )
})

TagHeadearLevel.displayName = 'TagHeadearLevel'
export default TagHeadearLevel
